import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SessionService } from '../../../../_services';

@Component({
    selector: 'session-survey-monkey',
    templateUrl: 'survey-monkey.component.html',
    styleUrls: ['survey-monkey.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class SessionSurveyMonkey implements OnInit {
    @Input() sessionId;

    trainingSession: any = {};
    registrations: any = [];
    selectedStudents: any[] = [];
    isLoading: boolean = true;
    studentsDto: any = {};

    constructor(private sessionService: SessionService) {}

    ngOnInit(): void {
        this.getSession();
        this.getRegisteredStudents();
    }

    private getSession(): void {
        this.sessionService
            .getTrainingSessionById(this.sessionId)
            .subscribe((trainingSession) => {
                this.trainingSession = trainingSession;
            });
    }

    getRegisteredStudents(): void {
        this.sessionService
            .getRegisteredStudents(this.sessionId)
            .subscribe((registration) => {
                if (registration.length === 0) {
                    this.isLoading = false;
                } else {
                    for (var i = 0; i < registration.length; i++) {
                        this.registrations.push(
                            ...registration[i].registrationDetails.map(
                                (registrationDetail) => ({
                                    ...registrationDetail,
                                })
                            )
                        );
                    }
                }
                this.isLoading = false;
            });
    }

    handleStudentArray(event, selectedStudent): void {
        let studentEvent = event.target;
        if (studentEvent.checked) {
            const studentDto: any = {};
            studentDto.lastName = selectedStudent.student.lastName;
            studentDto.firstName = selectedStudent.student.firstName;
            studentDto.email = selectedStudent.student.email;
            this.selectedStudents.push(studentDto);
        } else {
            this.selectedStudents.splice(
                this.selectedStudents.indexOf(selectedStudent),
                1
            );
        }
    }

    sendSurveyToStudent(surveyType: string): void {
        if (this.selectedStudents.length === 0) {
            alert('Aucun Stagiaire sélectionné');
            return;
        }
        this.sessionService
            .sendSurveyByMail(this.sessionId, surveyType, this.selectedStudents)
            .subscribe((res) => alert('Le mail a bien été envoyé !'));
    }

    existSurveyInTrainingSession(): boolean {
        return this.trainingSession.surveys.length !== 0;
    }

    redirectionToSurveyReport() {
        this.sessionService.getRedirectionToSurveyReport(this.sessionId);
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/survey-monkey/survey-monkey.component.ts